import { register } from 'register-service-worker'
import { EventBus } from '@/utils/eventBus'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    type: 'module',
    ready () {
      console.log('App is being served from cache by a service worker.')
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
      EventBus.$emit('sw-cached')
    },
    updatefound () {
      console.log('New content is downloading.')
      EventBus.$emit('sw-update-found')
    },
    updated () {
      console.log('New content is available please refresh.')
      EventBus.$emit('sw-updated')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
      EventBus.$emit('sw-offline')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
